import { NearBodyPartTextMap } from './constants';
import type { NearBodyPartType } from './types';

export const getSizeInfoText = (params: {
  nearBodyPart: NearBodyPartType;
  distanceFromBodyPart: number;
}): [string, string] => {
  const suffix =
    params.distanceFromBodyPart === 0
      ? ''
      : params.distanceFromBodyPart > 0
        ? ' 내려와요'
        : ' 올라와요';

  const distanceText =
    params.distanceFromBodyPart === 0
      ? '을 덮어요'
      : params.distanceFromBodyPart > 0
        ? ` 아래로 ${Math.abs(params.distanceFromBodyPart)}cm`
        : ` 위로 ${Math.abs(params.distanceFromBodyPart)}cm`;

  const text = `${NearBodyPartTextMap[params.nearBodyPart] ?? ''}${distanceText}`;

  return [text, suffix];
};

export const withEunNeun = (text: string): string => {
  if (!text) return text;
  const lastChar = text.charCodeAt(text.length - 1);
  const hasJongSeong = (lastChar - 0xac00) % 28 !== 0;
  return `${text}${hasJongSeong ? '은' : '는'}`;
};

export const getInputNudgeText = (params: {
  isPieceFullLengthDefaultValue: boolean;
  isUserHeightDefaultValue: boolean;
}): string => {
  const isAllDefaultValue =
    params.isPieceFullLengthDefaultValue && params.isUserHeightDefaultValue;

  if (isAllDefaultValue) {
    return '정확하게 보려면 정보 입력하기';
  }

  if (params.isUserHeightDefaultValue) {
    return '내 키 입력하고 정확하게 보기';
  }

  if (params.isPieceFullLengthDefaultValue) {
    return '총장 입력하고 더 정확하게 보기';
  }

  return '키/총장 수정하기';
};
